<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li v-if="privateInfoData.acf?.title"><router-link to="/privateinfo">{{ privateInfoData.acf?.title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="cms">
      <div class="container">
        <div class="cms-cont">
          <h2 v-if="privateInfoData.acf?.title && !isLoading">{{ privateInfoData.acf?.title }}</h2>
          <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 39px;">
            <PuSkeleton style="height: 30px;" :count="1"/>
          </div>
          <div v-if="privateInfoData.acf?.html_text && !isLoading" class="cms-cont__top" v-html="privateInfoData.acf?.html_text"></div>
          <div class="skeleton-parent" v-if="isLoading">
            <PuSkeleton style="height: 15px; padding-bottom: 30px;" :count="25"/>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import axios from "axios";
import { RouterLink } from 'vue-router';
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: 'PrivateInfo',
  components: {},
  data() {
    return {
      privateInfoData: {},
      isLoading: true,
    }
  },
  mounted() {
    const listH2 = this.$el.querySelectorAll(".cms-cont__top h2");
    listH2.forEach((element) => {
      element.style.textAlign = "center";
    });
  },
  computed: {
  },
  methods: {
  },
  created() {
    this.isLoading = true;
    getUrl(`/others_personal_info/${process.env.VUE_APP_ID_PRIVATEINFO}`)
    .then((response) => {
      this.privateInfoData = response.data;
      
      metaData(
        `${this.privateInfoData.acf?.title ? this.privateInfoData.acf?.title : 'サイトのご利用について'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGの個人情報の取り扱いについてご案内するページです。',
        'HARUMIFLAGタウンポータル',
        'article'
      )

      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    });
  },
}
</script>